<template>
	<div class="settings">
		<Titlebar title="Global Settings" />
		<Card>
			<div class="settings__intro">
				<h3>
					These settings apply globally, and are not tied to any specific
					campaign.
				</h3>
			</div>
			<GlobalsForm ref="form" :loading="submitting" @submit="onSubmit" />
		</Card>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import toast from '@/mixins/toast'
import Titlebar from '@/components/admin/Titlebar'
import Card from '@/components/shared/Card'
import GlobalsForm from '@/components/admin/GlobalsForm'

export default {
	name: 'GlobalSettings',
	data() {
		return {
			submitting: false
		}
	},
	methods: {
		...mapActions({
			setConfig: 'config/set'
		}),
		async onSubmit(data) {
			this.submitting = true
			try {
				// Update globals
				// const newConfig = await this.post('/globals/config', { body })
				await this.setConfig(data)
				this.toast('Successfully updated global settings.')
			} catch (err) {
				// Show toast with relevant error
				switch (err.name) {
					case 'APIValidationError':
						this.toastWarn('Please check for form errors and try again.')
						break
					default:
						this.toastErr(
							'Failed to update global settings. Please try again later.'
						)
						break
				}
			}
			this.submitting = false
		}
	},
	mounted() {
		// Pull global config into form
		this.$refs.form.populate(this.$store.state.config)
	},
	mixins: [toast],
	components: {
		Titlebar,
		Card,
		GlobalsForm
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.settings {
	&__intro {
		@include truncate-margin;
		margin-bottom: 2rem;
	}
}
</style>
